define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/ClientUtil',
	'internal_util/Configuration',
	'model/RecoveryStrategy',
	'service/EventListenerRegistry',
	'service/EidClientManager',
	'amdi18n-loader?!model/recoverystrategy/nls/WebstartRecoveryStrategy_strings'
//	'lib/dtjava'
], function (
	Logger,
	Util,
	UiUtil,
	ClientUtil,
	Configuration,
	RecoveryStrategy,
	EventListenerRegistry,
	EidClientManager,
	Strings
//	DTJava
) {
	'use strict';

	/**
	 * WebstartRecoveryStrategy class
	 */
	function WebstartRecoveryStrategy(eidClientManager) {
		var _eidClientId = 'http://ws.skidentity.de/oi/go/client/OpeneCardApp',
			_eidClientManager,
			_isStarted = false,
			_authenticationOption,
			_detectionTimeout,
			_eventListener;

		if (eidClientManager instanceof EidClientManager) {
			_eidClientManager = eidClientManager;
		} else {
			throw new Error('no valid eidClientManager found');
		}

		RecoveryStrategy.call(this, 'http://ws.skidentity.de/oi/rs/webstart');


		// private methods

		function log(method, message, data) {
			Logger.log('WebstartRecoveryStrategy', method, message, data);
		}

		function callLog(method, message, data, event, callbacks) {
			log(method, message, data);
			EventListenerRegistry.callListeners(event, data, function () {
				Util.callCallbacks(callbacks, data);
			});
		}

		function checkJava() {
//			var retVal = DTJava.validate(new DTJava.Platform(
//					{ jvm : Configuration.get('OPEN_ECARD_MINIMUM_JRE_VERSION') + '+' }));
//
//			if (typeof retVal !== 'undefined' && retVal !== null) {
//				if (retVal.jreStatus() !== 'ok' && !retVal.isUnsupportedPlatform()) {
//					return true;
//				}
//				return false;
//			}
			return !ClientUtil.isMobileClient();;
		}


		// public methods

		this.name = function () {
			return 'Open eCard App';
		};

		this.icon = function () {
			return UiUtil.getImage('WEBSTART_RECOVERY_BUTTON');
		};
		
		this.description = function () {
			return Strings.description;
		};

		this.isUsable = function (authenticationOption) {
//			var _name = 'isUsable',
//				richclient = _eidClientManager.eidClientById(_eidClientId);
//
//			if (!checkJava()) {
//				log(_name, Strings.java_not_supported);
//				return false;
//			}
//
//			if (richclient === null) {
//				log(_name, Strings.app_not_available);
//				return false;
//			}
//
//			if (!richclient.supportsPlatform()) {
//				log(_name, Strings.platform_not_supported);
//				return false;
//			}
//
//			if (!richclient.supportsAuthenticationOption(authenticationOption)) {
//				log(_name, Strings.authentication_option_not_supported);
//				return false;
//			}

			return !ClientUtil.isMobileClient();
		};

		this.start = function (authenticationOption, callbacks, errorCallbacks) {
			var _name = 'start',
				self = this;

			if (_isStarted) {
				return;
			}

			_authenticationOption = authenticationOption;

			_eventListener = function (eidClient) {
				if (eidClient.id() === _eidClientId) {
					window.clearTimeout(_detectionTimeout);

					_eidClientManager.stopDetection(_authenticationOption);

					callLog(_name, Strings.succeeded, self, 'RECOVERY_STRATEGY_SUCCEEDED', callbacks);
				}
			};

			function startTimer() {
				_detectionTimeout = setTimeout(function () {
					_isStarted = false;

					EventListenerRegistry.removeListener('EID_CLIENT_DETECTED', _eventListener);

					_eidClientManager.stopDetection(_authenticationOption);

					callLog(_name, Strings.failed, self, 'RECOVERY_STRATEGY_FAILED', errorCallbacks);
				}, Configuration.get('RECOVERY_STRATEGY_WEBSTART_TIMEOUT'));
			}

			_isStarted = true;

			callLog(_name, Strings.started, this, 'RECOVERY_STRATEGY_STARTED');

			EventListenerRegistry.addOneTimeListener('EID_CLIENT_DETECTED', _eventListener);

//			startTimer();
//
//			_eidClientManager.startDetection(_authenticationOption);

			// launch webstart app or download JNLP file
//			try {
//				DTJava.launch(
//						new DTJava.App(Configuration.get('OPEN_ECARD_WEBSTART_JNLP_URL')),
//						new DTJava.Platform({ jvm : Configuration.get('OPEN_ECARD_MINIMUM_JRE_VERSION') + '+' }), {
//							onDeployError : function () {
//								window.open(Configuration.get('OPEN_ECARD_WEBSTART_JNLP_URL'), '_self');
//							},
//							onInstallNeeded : function () {
//								window.clearTimeout(_detectionTimeout);
//
//								Util.callCallbacks(callbacks, {
//									isInstalled : function () {
//										window.open(Configuration.get('OPEN_ECARD_WEBSTART_JNLP_URL'), '_self');
//										startTimer();
//									},
//									isNotInstalled : function () {
//										window.open(Configuration.get('JAVA_DOWNLOAD_URL'), '_blank');
//									},
//									startApp : function () {
//										window.open(Configuration.get('OPEN_ECARD_WEBSTART_JNLP_URL'), '_self');
//										startTimer();
//									}
//								});
//							}
//						});
//			} catch (error) {
				window.open(Configuration.get('OPEN_ECARD_DOWNLOAD_URL'), '_blank');
//			}
		};

		this.stop = function () {
			if (!_isStarted) {
				return;
			}

			_isStarted = false;

			EventListenerRegistry.removeListener('EID_CLIENT_DETECTED', _eventListener);

			_eidClientManager.stopDetection(_authenticationOption);

			window.clearTimeout(_detectionTimeout);

			callLog('stop', Strings.stopped, this, 'RECOVERY_STRATEGY_STOPPED');
		};
	}

	WebstartRecoveryStrategy.prototype = Object.create(RecoveryStrategy.prototype);

	return WebstartRecoveryStrategy;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/recoverystrategy/WebstartRecoveryStrategy.js
// module id = 157
// module chunks = 3